import { FunctionComponent } from 'react';

import { SettingsColor } from './settings-color';

interface SettingsBackgroundColorProps {}

export const SettingsBackgroundColor: FunctionComponent<SettingsBackgroundColorProps> = () => {
  return (
    <SettingsColor
      id="background-color"
      showGlobalHeading
      textfieldLabel="Background Color (Hex Code)"
      type="backgroundColor"
    />
  );
};
